'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint-disable prefer-const,import/no-mutable-exports */


var _fetch = require('./fetch');

var _fetch2 = _interopRequireDefault(_fetch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var naroujs = void 0;

naroujs = function naroujs() {
  return _fetch2.default.apply(undefined, arguments);
};

naroujs.pickup = function () {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return naroujs(_extends({ ispickup: 1, order: 'hyoka', lim: 200 }, params));
};

naroujs.r18 = function () {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return naroujs(params, { api: 'novel18api' });
};

naroujs.noc = function () {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return naroujs(_extends({ nocgenre: 1 }, params), { api: 'novel18api' });
};

naroujs.mnlt = function () {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return naroujs(_extends({ nocgenre: 2 }, params), { api: 'novel18api' });
};

naroujs.bl = function () {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return naroujs(_extends({ nocgenre: 3 }, params), { api: 'novel18api' });
};

naroujs.mid = function () {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return naroujs(_extends({ nocgenre: 4 }, params), { api: 'novel18api' });
};

naroujs.rank = function () {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return naroujs(params, { api: 'rank' });
};

naroujs.fame = function () {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return naroujs(params, { api: 'fame' });
};

exports.default = naroujs;
module.exports = exports['default'];


// WEBPACK FOOTER //
// ./src/index.js